export enum WorkOrderTypes {
  INSTALL = 'Install',
  COMMERCIAL_INSTALL = 'Commercial Install',
  UPGRADE = 'Upgrade',
}

export type EicMessage = {
  eicMessage: string[];
  productTypeId: string;
  cpqConsentDatetime: string;
  cpqConsentReferenceId: string;
  cpqUserConsent: string;
};
